import { apiAuthed } from "./api";

/** The signed-in customer's profile, as the backend stores it (customers/{uid}). */
export interface Profile {
  phone: string | null;
  fullName: string | null;
  nickname: string | null;
  photoDataUrl: string | null;
  /** Optional contact email; prefills checkout and receives order confirmations. */
  email: string | null;
  /** This customer's own, shareable referral code. */
  referralCode: string;
  referredByCode: string | null;
  completed: boolean;
}

export interface ProfileInput {
  fullName: string;
  nickname?: string;
  photoDataUrl?: string | null;
  referralCode?: string;
  /** Omit to keep the stored email; null or "" removes it. */
  email?: string | null;
}

export const fetchProfile = () => apiAuthed<Profile>("GET", "/me/profile");

export const saveProfile = (input: ProfileInput) => apiAuthed<Profile>("PUT", "/me/profile", input);

export const NAME_MIN = 2;
export const NAME_MAX = 80;
export const REFERRAL_PATTERN = /^[A-Za-z0-9]{4,20}$/;
